module.exports = __webpack_public_path__ + "static/Opensans-LightItalic.6943fb6f.ttf";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Opensans-LightItalic.ttf
// module id = 528
// module chunks = 35783957827783